import React, { useState } from 'react';
import './TicketDetails.scss';
import '../../Dashboard.scss';
import Ticket from '../../../../images/ticket.png';
import { useNavigate } from 'react-router-dom';
import { updateAssetList, updateSelectedAsset } from '../../../navigation/AssetGroupsSlice';
import { useAppDispatch, useAppSelector } from '../../../../hooks/storeHooks';

interface TicketDetail {
  wellName?: string | undefined;
  ticket?: string | undefined;
  operator?: string | undefined;
  status?: string | undefined;
  assignedTo?: string | undefined;
  subject?: string | undefined;
  assetID?: string | undefined;
}

const NewTicketDetails: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const newTicketDetails = useAppSelector((state) => state.dashboard.filterNewTicketDetails) as TicketDetail[] | null;
  const newTicketsCount = useAppSelector((state) => state.dashboard.newTicketsCount);
  const activeTab = sessionStorage.getItem('activeTabIndex');
  const [sortConfig, setSortConfig] = useState<{ key: keyof TicketDetail; direction: 'asc' | 'desc' } | null>(null);

  // Function to request sorting
  const requestSort = (key: keyof TicketDetail) => {
    let direction: 'asc' | 'desc' = 'asc';
    if (sortConfig?.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  // Function to perform sorting
  const sortedTicketDetails = React.useMemo(() => {
    const sortableItems = newTicketDetails ? [...newTicketDetails] : [];
    if (sortConfig !== null) {
      sortableItems.sort((a, b) => {
        const aValue = a[sortConfig.key];
        const bValue = b[sortConfig.key];

        if (aValue === undefined || bValue === undefined) {
          return 0; // Return 0 when either value is undefined
        }

        if (aValue < bValue) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableItems;
  }, [newTicketDetails, sortConfig]);

  const handleWellName = (wellName: string, assetID: string) => {
    window.scrollTo(0, 0);
    if (activeTab !== '0') {
      sessionStorage.setItem('activeTabIndex', '0');
    }
    const groupList = newTicketDetails
      ? newTicketDetails?.map((well) => {
          return {
            assetId: well?.assetID,
            assetName: well?.wellName,
            industryApplicationId: 4,
          };
        })
      : [];

    const selectedAsset = {
      assetName: wellName,
      assetGroupName: 'Well Groups',
      assetId: assetID,
      searchString: undefined,
    };

    if (selectedAsset) {
      sessionStorage.setItem('selectedWellName', JSON.stringify(selectedAsset));
    }

    if (groupList) {
      sessionStorage.setItem('wellNameList', JSON.stringify(groupList));
    }

    dispatch(updateSelectedAsset(selectedAsset));
    dispatch(updateAssetList(groupList));
    navigate('/layout/assets/?tab=details');
  };

  return (
    <>
      <div className='card new-ticket-details'>
        <div className='table-header-section'>
          <img src={Ticket} alt='' />
          <div className='title'>New tickets</div>
        </div>
        <p className='ticket-count'>You currently have {newTicketsCount} new ticket{newTicketsCount > 1 ? 's' : 's'}.</p>

        {newTicketsCount > 0 && (
          <div
            id='newTicketsDetailsWidgetDiv'
            className='table-container-dashboard'
            style={{ width: '100%', height: '100%', backgroundColor: '#001023', paddingTop: '8px' }}
          >
            <table className='w-100'>
              <thead>
                <tr className='table-header-cell'>
                  <th className='table-header-item well-name' onClick={() => requestSort('wellName')}>
                    Well name {sortConfig?.key === 'wellName' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : '↑'}
                  </th>
                  <th className='table-header-item ticket' onClick={() => requestSort('ticket')}>
                    Ticket # {sortConfig?.key === 'ticket' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : '↑'}
                  </th>
                  <th className='table-header-item status' onClick={() => requestSort('status')}>
                    Status {sortConfig?.key === 'status' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : '↑'}
                  </th>
                  <th className='table-header-item subject' onClick={() => requestSort('subject')}>
                    Subject {sortConfig?.key === 'subject' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : '↑'}
                  </th>
                </tr>
              </thead>
              <tbody>
                {sortedTicketDetails?.map((ticket, index) => (
                  <tr key={index} className='table-row-general'>
                    <td className='well-name' onClick={() => handleWellName(ticket.wellName ?? '', ticket?.assetID ?? '')}>
                      {ticket.wellName ?? '-'}
                    </td>
                    <td className='ticket'>{ticket.ticket ?? '-'}</td>
                    <td className='status'>{ticket.status ?? '-'}</td>
                    <td className='subject' id='subject' data-title={ticket.subject}>
                      {ticket.subject && ticket.subject?.length >= 30
                        ? `${ticket.subject.substring(0, 15)}...`
                        : ticket.subject}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
};

export default NewTicketDetails;